__webpack_require__.p = "https://store-uy.tea.mag.dev/";